export default function lastIndex<T>(items: T[]) {
  if (!items || !items.length) {
    return -1
  }

  return items.length - 1
}
